export default "__VITE_ASSET__sDr69BRq__"